import { useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Pro013CampaignData } from "../create-pro013-form";
import { StoreSelector } from "../shared/store-selector";

interface StepTwoStoresProps {
  data: Pro013CampaignData;
  updateData: (data: Partial<Pro013CampaignData>) => void;
  nextStep: () => void;
  prevStep: () => void;
}

export default function StepTwoStores({ data, updateData, nextStep, prevStep }: StepTwoStoresProps) {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const isFormValid = useMemo(() => {
    return data.allStores || data.stores.length > 0;
  }, [data.allStores, data.stores]);

  const handleNext = () => {
    if (!data.allStores && data.stores.length === 0) {
      setErrors({ stores: "Selecione pelo menos uma loja" });
      return;
    }
    setErrors({});
    nextStep();
  };

  return (
    <div className="space-y-4 animate-in fade-in duration-300">
      <StoreSelector
        allStores={data.allStores}
        selectedStores={data.stores}
        updateData={updateData}
        error={errors.stores}
        clearError={() => setErrors({})}
      />

      <div className="flex justify-between pt-2">
        <Button variant="outline" onClick={prevStep} className="w-full md:w-auto">
          <ChevronLeft className="mr-2 h-4 w-4" />
          Voltar
        </Button>
        <Button onClick={handleNext} disabled={!isFormValid} className="w-full md:w-auto">
          Continuar
          <ChevronRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
